import { gql } from '@apollo/client';

export const CERTIFICATES = gql`
  query certificates($args: CertificatesInput!) {
    certificates(args: $args) {
      pageInfo {
        totalCount
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          filePath
          sha256
          sha1
          signature
          effectivePermissions
          subjectDN
          issuerDN
          serial
          startDate
          expireDate
          bitSize
          publicKeyAlgorithm
          signatureAlgorithm
          uniqueHash
          publicKeyMatchHash
          e
          curve
          selfSigned
          isCa
          expired
          invalidities
          invaliditiesCount
          algorithmType
          invalid
          fileOffset
          version
          privKeyCompromised
          # Issuer detail
          issuerSerialNumber
          issuerCountry
          issuerOrganization
          issuerCommonName
          issuerOrgUnit
          # Subject details
          subjectSerialNumber
          subjectCommonName
          subjectOrganization
          subjectOrgUnit
          subjectCountry
          subjectProvince
          subjectLocality
          # Extensions
          keyUsage
          issuingCertUrl
          ocspServer
          crlDistributionPoints
          # Subject Alternative Names
          altDnsNames
          altEmailAddresses
          altIps
          altUris
          correlations {
            assetName
            assetId
          }
          correlationsCount
          currentRemediation {
            certificate {
              filePath
              sha256
            }
            status
            description
            author
            createdAt
          }
        }
      }
    }
  }
`;

export const CERTIFICATES_OLD = gql`
  query certificates($args: CertificatesInput!) {
    certificates(args: $args) {
      pageInfo {
        totalCount
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          filePath
          sha256
          sha1
          signature
          effectivePermissions
          subjectDN
          issuerDN
          serial
          startDate
          expireDate
          bitSize
          publicKeyAlgorithm
          signatureAlgorithm
          e
          curve
          selfSigned
          isCa
          expired
          invalidities
          invaliditiesCount
          correlations {
            assetName
            assetId
          }
          correlationsCount
        }
      }
    }
  }
`;

export const CERTIFICATE_EXTERNAL_FILTER = gql`
  query certificateExternalFilters($args: CertificateExternalFiltersInput!) {
    certificateExternalFilters(args: $args) {
      totalClassical
      totalPqc
    }
  }
`;

export const CERTIFICATE_DETAILS = gql`
  query certificateDetails($args: CertificatesInput!) {
    certificates(args: $args) {
      edges {
        node {
          filePath
          sha256
          sha1
          signature
          effectivePermissions
          subjectSerialNumber
          startDate
          expireDate
          bitSize
          publicKeyAlgorithm
          signatureAlgorithm
          uniqueHash
          publicKeyMatchHash
          e
          curve
          selfSigned
          isCa
          expired
          invalidities
          invaliditiesCount
          algorithmType
          fileOffset
          version
          privKeyCompromised
          issuerCountry
          issuerOrganization
          issuerCommonName
          issuerOrgUnit
          subjectCommonName
          subjectOrganization
          subjectOrgUnit
          subjectCountry
          subjectProvince
          subjectLocality
          keyUsage
          issuingCertUrl
          ocspServer
          crlDistributionPoints
          altDnsNames
          altEmailAddresses
          altIps
          altUris
          currentRemediation {
            certificate {
              filePath
              sha256
            }
            status
            description
            author
            createdAt
          }
        }
      }
    }
  }
`;

export const REMEDIATE_CERTIFICATES = gql`
  mutation remediateCertificates($args: RemediateCertificatesInput!) {
    remediateCertificates(args: $args) {
      certificate {
        filePath
        sha256
      }
      status
      description
      author
      createdAt
      errorMessage
    }
  }
`;
